// extracted by mini-css-extract-plugin
export var icon = "_9-1";
export var subtext = "_9-0";